import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, FIREBASE_EVENTS, PLAN_STATUS_KEY } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function NegotiationCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { contractStatus } = useSelector(({ contract: { selected } }) => ({
    contractStatus: selected.contractStatus,
  }))

  function handleClick() {
    const isCanceledContract = contractStatus === PLAN_STATUS_KEY.ST_CONT_CANCELADO
    const event = isCanceledContract
      ? FIREBASE_EVENTS.CLICK_ON_CANCELED_CONTRACT_NEGOTIATION_BILLS
      : FIREBASE_EVENTS.CLICK_ON_BILLET_NEGOTIATION

    sendEvent(event)
    dispatch(setDrawer(DRAWER_KEY.NEGOTIATION))
  }

  return <BaseCard onClick={handleClick} text='Negociar faturas' icon={<STATICS.BILL_CHECK />} />
}
